/**
 * Check if a password has been found in known data breaches
 * using the Have I Been Pwned API (k-anonymity model — no password is sent in clear).
 */
export async function isPasswordPwned(password: string): Promise<{ pwned: boolean; count: number }> {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest("SHA-1", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("").toUpperCase();

  const prefix = hashHex.slice(0, 5);
  const suffix = hashHex.slice(5);

  const res = await fetch(`https://api.pwnedpasswords.com/range/${prefix}`);
  if (!res.ok) return { pwned: false, count: 0 };

  const text = await res.text();
  const match = text.split("\n").find((line) => line.startsWith(suffix));
  if (!match) return { pwned: false, count: 0 };

  const count = parseInt(match.split(":")[1].trim(), 10);
  return { pwned: true, count };
}
